import { show404 } from '@shared/lib/page-error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  if (!Number(to.params.assessment)) return show404()
})
